import type { ReactNode } from "react";
import { Button } from "@/components/ui/Button";

interface AdminFormDrawerProps {
  title: string;
  description?: string;
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

export function AdminFormDrawer({ title, description, isOpen, onClose, children }: AdminFormDrawerProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/70 backdrop-blur-sm">
      <button className="absolute inset-0 cursor-default" type="button" aria-label="Close drawer" onClick={onClose} />
      <aside className="relative h-full w-full max-w-xl overflow-y-auto border-l border-cyan-300/20 bg-surface p-5 shadow-panel">
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-teal-200">Edit</p>
            <h2 className="mt-2 font-display text-2xl font-bold uppercase text-white">{title}</h2>
            {description && <p className="mt-2 text-sm leading-6 text-content-secondary">{description}</p>}
          </div>
          <Button variant="ghost" size="sm" onClick={onClose}>
            Close
          </Button>
        </div>
        {children}
      </aside>
    </div>
  );
}
